import React, { useState, useEffect } from 'react';

const TypingAnimation = (props) => {
  const [text, setText] = useState('');
  const [isAnimationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    setText('');
    setAnimationComplete(false);

    const totalCharacters = props.text.length;
    let currentIndex = 0;

    const typingTimeout = setTimeout(function type() {
      setText(props.text.substring(0, currentIndex));

      if (currentIndex < totalCharacters) {
        currentIndex += 1;
        setTimeout(type, 50); // 調整打字速度，這裡是 50 毫秒
      } else {
        setAnimationComplete(true);
      }
    }, 50); // 起始打字速度，這裡是 50 毫秒

    return () => clearTimeout(typingTimeout);
  }, [props.text]);

  return (
    <div>
      <p className={`typing-animation ${isAnimationComplete ? 'animation-complete' : ''}`}>
        {text}
      </p>
    </div>
  );
};

export default TypingAnimation;
